import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'HealthSystem',
  inputShow: gql`
    query healthSystems($input: HealthSystemQueryInput) {
      healthSystems(input: $input) {
        id
        label
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'VMS',
    label: 'Health Systems',
  },
};
